import React from "react";
import PropTypes from "prop-types";
import { ErrorMessage, useFormikContext } from "formik";
import classNames from "classnames";

import { states } from "../states";
import WebformElements from "../webform-elements";

const Details = ({ item, token }) => {
  const { values } = useFormikContext();

  const { invisible, visible, optional, required } = states(
    item["#states"],
    values
  );

  return (
    <details
      className={classNames({
        "form-group webform-details": true,
        hidden: invisible || !visible,
      })}
      open={!!item["#open"]}
      style={item["#flex"] ? { flex: item["#flex"] } : {}}
    >
      <summary>
        {item["#title"]}
        {(!!item["#required"] || required) && !optional && visible && (
          <span className="required">*</span>
        )}
      </summary>

      <WebformElements items={item.elements} token={token} />

      <ErrorMessage
        role="region"
        aria-live="polite"
        component="span"
        name={item.id}
        className="error-message"
      />

      {!!item["#description"] && (
        <small className="form-description text-muted form-text">
          {item["#description"]}
        </small>
      )}
    </details>
  );
};

Details.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    elements: PropTypes.array,
    "#states": PropTypes.array,
    "#description": PropTypes.string,
    "#title": PropTypes.string,
    "#flex": PropTypes.number,
    "#required": PropTypes.object,
    "#open": PropTypes.string,
  }),
  token: PropTypes.string.isRequired,
};

export default Details;
